__turbopack_context__.v({
  "anchor": "combobox-module__py9JEG__anchor",
  "button": "combobox-module__py9JEG__button",
  "content": "combobox-module__py9JEG__content",
  "empty": "combobox-module__py9JEG__empty",
  "error": "combobox-module__py9JEG__error",
  "floatingLabel": "combobox-module__py9JEG__floatingLabel",
  "glassLayer": "combobox-module__py9JEG__glassLayer",
  "icon": "combobox-module__py9JEG__icon",
  "inner": "combobox-module__py9JEG__inner",
  "input": "combobox-module__py9JEG__input",
  "item": "combobox-module__py9JEG__item",
  "labelText": "combobox-module__py9JEG__labelText",
  "list": "combobox-module__py9JEG__list",
  "root": "combobox-module__py9JEG__root",
  "triggerWrap": "combobox-module__py9JEG__triggerWrap",
});
